import { jobsSDRQuotaTypes } from '@/components/partials/jobs/constants/selectableOptions';
import * as utils from '@/components/partials/jobs/JobsInquiryForm/utils/common';
import {
  getAverageDealSizeFormField,
  getQuotaAttainmentPerLastYearFormField,
  getQuotaAttainmentPerPeriodFormField,
} from '@/components/partials/jobs/JobsInquiryForm/utils/formFields';
import type { JobsFormField } from '@/components/partials/public-portfolio/PortfolioJobsInquirySection/PortfolioJobsInquirySectionProfile/types';

export default (): JobsFormField[] => {
  return [
    {
      attributeName: 'sdrQuotaTypes',
      type: 'BravadoSelectV3',
      getAttrs() {
        return {
          label: 'How is your quota measured?',
          options: jobsSDRQuotaTypes.map(utils.mapOnboardingOptionsToSelectInput),
          multi: true,
        };
      },
    },
    {
      attributeName: 'sdrQuotaPerPeriod',
      type: 'BravadoTextInputV3',
      getAttrs() {
        return {
          label: 'What is your current quota?',
          placeholder: 'Type your answer here',
          multiline: true,
        };
      },
    },
    {
      ...getQuotaAttainmentPerPeriodFormField(),
      getIsHidden() {
        return false;
      },
    },
    getQuotaAttainmentPerLastYearFormField(),
    getAverageDealSizeFormField(),
  ];
};
